import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../i18n/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-gold/10 bg-ink" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <Logo />
          <nav className="flex flex-wrap gap-7 text-[13px] tracking-[0.14em] uppercase text-cream/60">
            <Link to="/" className="hover:text-goldlight transition-colors" data-testid="footer-link-home">{t("footer.home")}</Link>
            <Link to="/learn" className="hover:text-goldlight transition-colors" data-testid="footer-link-infos">{t("footer.infos")}</Link>
            <Link to="/about" className="hover:text-goldlight transition-colors" data-testid="footer-link-about">{t("footer.about")}</Link>
            <Link to="/nous-achetons" className="hover:text-goldlight transition-colors" data-testid="footer-link-buy">{t("footer.buy")}</Link>
            <Link to="/confidentialite" className="hover:text-goldlight transition-colors" data-testid="footer-link-privacy">{t("footer.privacy")}</Link>
            <a href="https://www.encansdesparois.com" target="_blank" rel="noreferrer" className="hover:text-goldlight transition-colors" data-testid="footer-link-auctions">
              {t("footer.auctions")}
            </a>
          </nav>
        </div>
        <div className="hairline my-8" />
        <div className="flex flex-col sm:flex-row justify-between gap-4 text-xs text-mutedc">
          <p>{t("footer.copyright")}</p>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors">
            {t("footer.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
